import ReactDOM from 'react-dom'
import videojs from 'video.js'
import React from 'react'
import ForwardIcon from '../../../../assets/codicons/video-icons/for-15'
import BackIcon from '../../../../assets/codicons/video-icons/rewind-15'
import TrackableSection, { Trackable } from '../../tracking'

const vjsComponent = videojs.getComponent('Component')
const SEEK_TIME_BY = 15

class SeekerButtons extends vjsComponent {
  constructor (player, options) {
    super(player, options)

    this.videoTrackingInfo = options.videoTrackingInformation

    this.mountElement = this.mountElement.bind(this)
    this.createAutoplaySwitch = this.createSeekerButtons.bind(this)
    this.seek = this.seek.bind(this)

    this.state = {
      player,
      seeking: false
    }

    player.ready(() => {
      this.mountElement()
    })

    let loadingSpinner = player.$('.vjs-loading-spinner')

    player.on('seeking', () => {
      if (!loadingSpinner.classList.contains('active')) {
        loadingSpinner.className += ' active'
      }
      this.setState({ seeking: true })
    })

    player.on('seeked', () => {
      loadingSpinner.className = 'vjs-loading-spinner'
      this.setState({ seeking: false })
    })

    player.on('progress', () => {
      if (!this.state.seeking) {
        loadingSpinner.className = 'vjs-loading-spinner'
      }
    })

    /* Remove React root when component is destroyed */
    this.on('dispose', () => {
      ReactDOM.unmountComponentAtNode(this.el())
    })
  }

  mountElement () {
    ReactDOM.render(this.createSeekerButtons(), this.el())
  }

  /**
   * Navigates the time in the video by 15s
   * @param {string} direction The direction in which to increase or decrease video time.
   * Possible values: 'rewind', 'forward'
   */
  navigateTime (direction) {
    let currentTime = this.state.player.currentTime()
    if (direction === 'rewind') {
      currentTime -= SEEK_TIME_BY
    } else if (direction === 'forward') {
      currentTime += SEEK_TIME_BY
    }
    this.state.player.currentTime(currentTime)
  }

  seek (seekDirection, callback) {
    const player = this.state.player
    const seekStartTime = player.currentTime()

    this.navigateTime(seekDirection)

    // Attach and detach seeked event immediately after this method is complete.  This is
    // to prevent it from firing if the user seeks by dragging the duration slider.
    player.one('seeked', e => {
      const seekEndTime = player.currentTime()
      callback(e, {
        event: seekDirection,
        originTime: seekStartTime,
        currentTime: seekEndTime
      })
    })
  }

  createSeekerButtons () {
    return (
      <TrackableSection
        urlPrefix='/api/v2'
        globalParams={this.videoTrackingInfo}
        defaultUrl='/video_tracks'
        disable
      >
        <Trackable>
          {({ updateToTrack }) => {
            return (
              <React.Fragment>
                <div
                  className='rewind-15'
                  onClick={() => {
                    this.seek('rewind', (_, infoToTrack) => {
                      updateToTrack('seek', infoToTrack)
                    })
                  }}
                >
                  <BackIcon />
                </div>
                <div
                  className='forward-15'
                  onClick={() => {
                    this.seek('forward', (_, infoToTrack) => {
                      updateToTrack('seek', infoToTrack)
                    })
                  }}
                >
                  <ForwardIcon />
                </div>
              </React.Fragment>
            )
          }}
        </Trackable>
      </TrackableSection>
    )
  }
}

vjsComponent.registerComponent('SeekerButtons', SeekerButtons)

export default SeekerButtons
